import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import {mutations} from './mutations';
import { actions } from './actions';
import {userState} from '@/store/User';
import {friendState} from '@/store/Friends';
import {violationState} from '@/store/Violations';
import {rateState} from '@/store/RateReviewFaq';
import {getters} from './getters';
Vue.use(Vuex);



const storeOpt: StoreOptions<RootState> = {
    state: {
        signedIn: false,
        currentUser: undefined,
    },
    mutations,
    actions,
    getters,
    modules: {
        userState,
        friendState,
        violationState,
        rateState,
    },
};

export const store =  new Vuex.Store<RootState>(storeOpt);
